import { render, staticRenderFns } from "./DocumentTable.vue?vue&type=template&id=2c7e0e63&scoped=true"
import script from "./DocumentTable.vue?vue&type=script&lang=js"
export * from "./DocumentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7e0e63",
  null
  
)

export default component.exports